<template>
  <i
    :class=" classes(n(), [$props.activated, n('--activated')], [$props.horizontal, n('--horizontal')], [$props.dashed, n('--dashed')])"
  />
</template>

<script lang="ts">
import { defineComponent } from 'virtual-vue';
import { stepItemIconLineProps } from '../props';
import { stepItemEmits } from '../item-emits';
import { createNamespace } from '../../utils/components';

const { name, n, classes } = createNamespace('step-item-line');

export default defineComponent({
  name,
  props: stepItemIconLineProps,
  emits: stepItemEmits,
  setup() {
    return {
      n,
      classes,
    };
  },
});
</script>
